import { MeidlyToolsData } from "@/app/(components)/specifics/pages/Home/Meidly/MeidlyToolsData";
import { TKey } from "@/app/translations/TKey";
import { CATEGORY_IDS_WITH_ARTICLES } from "../BlogArticles/BlogArticles.logic";

export const BLOG_CATEGORY_ALL = "all";

export type BlogCategoryItem = {
  id: string;
  labelKey: TKey;
  disabled: boolean;
};

export const BLOG_CATEGORIES: BlogCategoryItem[] = [
  { id: BLOG_CATEGORY_ALL, labelKey: TKey.BLOG_CAT_ALL, disabled: false },
  ...MeidlyToolsData[0].tools.map((tool) => ({
    id: tool.id,
    labelKey: tool.title,
    disabled: !CATEGORY_IDS_WITH_ARTICLES.has(tool.id),
  })),
];

export function getCategoryLabelKey(id: string): TKey | undefined {
  return BLOG_CATEGORIES.find((category) => category.id === id)?.labelKey;
}
